import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { VwAuthService } from 'vwappservices';
import { DataManipService } from './data-sharing.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private vwAuth = inject(VwAuthService);
  private router = inject(Router);
  private data = inject(DataManipService);

  loginsignup(params: any): Observable<any> {
    return from(this.vwAuth.login('user/userlogin', params));
  }

  async logout(): Promise<void> {
    await this.vwAuth.logout('user/userLogout');
    this.data.loginData = {};
    try {
      sessionStorage.removeItem('loginData');
    } catch {
      // ignore — non-fatal if sessionStorage is unavailable
    }
    this.router.navigateByUrl('/login');
  }
}
